import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger'; // eslint-disable-line import/no-extraneous-dependencies
import thunk from 'redux-thunk';
import { wtaMiddleware } from './analytics';
import gapi from './gapi';
import rootReducer from './reducer';
import PusherClient from './util/pusher';
export var prepareMiddleWare = function prepareMiddleWare() {
  var pusherClient = new PusherClient();
  var enhancers = [thunk.withExtraArgument({
    gapi: gapi,
    pusherClient: pusherClient
  }),
  // Initialize wta middleware even if `initRSW` is false.
  // Events may still  be dispatched to a rsw client initialized by a host app.
  wtaMiddleware];

  /*eslint no-constant-condition: "off"*/
  if (!['production', 'test'].includes(process.env.NODE_ENV)) {
    var logger = createLogger({
      collapsed: true
    });
    enhancers.push(logger);
  }
  return enhancers;
};
var configureStore = function configureStore(initialState) {
  var globalWindow = typeof window !== 'undefined';
  if (!globalWindow) {
    return createStore(rootReducer, initialState);
  }
  var middleWare = prepareMiddleWare();
  var composeEnhancers = compose;

  /*eslint no-constant-condition: "off"*/
  if (!['production'].includes(process.env.NODE_ENV)) {
    // eslint-disable-next-line no-underscore-dangle
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      // eslint-disable-next-line no-underscore-dangle
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware.apply(void 0, _toConsumableArray(middleWare))));
};
export default configureStore;